<script>
export default {
  name: 'Timeline',
  props: {
    boxShadow: {
      type: Boolean,
      default: true
    }
  }
};
</script>

<template>
  <div
    :class="{
      'timeline': true,
      'has-box-shadow': boxShadow
    }"
  >
    <ul>
      <slot />
    </ul>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.timeline {
  padding-left: 12rem;
  margin-bottom: 1.5rem;

  ul {
    position: relative;
    border-left: solid 0.2rem $--color-primary;
    border-top-right-radius: 0.25rem;
    border-bottom-right-radius: 0.25rem;
    background-color: $--color-white;
    color: $--color-gray-90;
    list-style: none;
    padding: 0;
    margin: 0;
  }

  &.has-box-shadow ul {
    box-shadow: $--box-shadow-small;
  }

  @include breakpoint('md-and-down') {
    padding-left: 0;
  }
}
</style>
